import React from "react";

import { getPreviewFramePrintFontSize } from "@/utils/qrEditorHelper";

import { QRFRameToPrintProps } from "../types";

import { uriText } from "./uri";

import "../styles.scss";

export const TakeawayFrameToDownload = (
  props: QRFRameToPrintProps
): React.SVGProps<SVGSVGElement> => {
  const {
    text,
    textColor,
    frameColor,
    frameBackgroundColor,
    height = 1200,
    qrSvg,
    width = 900,
  } = props;

  const fontSize = getPreviewFramePrintFontSize(text?.length);
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill="none">
      <style>
        {`
              @font-face {
                font-family: 'Nunito Sans';
                src: url(${uriText});
                font-weight: bold
              }
            `}
      </style>
      <g id="surface1">
        <path
          fillRule="nonzero"
          fill="white"
          fillOpacity="1"
          strokeWidth="1"
          stroke="#BFBFBF"
          d="M 7.999875 0.5 L 88.000125 0.5 C 92.142 0.5 95.500125 3.857839 95.500125 8 L 95.500125 120 C 95.500125 124.142161 92.142 127.5 88.000125 127.5 L 7.999875 127.5 C 3.858 127.5 0.499875 124.142161 0.499875 120 L 0.499875 8 C 0.499875 3.857839 3.858 0.5 7.999875 0.5 Z M 7.999875 0.5 "
          transform="matrix(10.416667,0,0,10.414062,0,0)"
        />

        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 114.175781 203.421875 C 114.175781 198.730469 114.175781 194.039062 114.175781 189.351562 C 117.644531 183.261719 122.914062 179.453125 129.984375 177.917969 C 376.484375 176.746094 622.988281 176.746094 869.488281 177.917969 C 885.171875 182.113281 889.5625 191.785156 882.664062 206.9375 C 880.527344 209.660156 877.894531 211.710938 874.757812 213.09375 C 624.742188 214.265625 374.730469 214.265625 124.714844 213.09375 C 120.285156 210.703125 116.769531 207.476562 114.175781 203.421875 Z M 114.175781 203.421875 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 127.148438 263.738281 C 375.992188 263.445312 624.835938 263.738281 873.679688 264.617188 C 886.632812 272.121094 889.269531 282.382812 881.582031 295.394531 C 879.089844 297.082031 876.457031 298.550781 873.679688 299.792969 C 624.25 300.964844 374.820312 300.964844 125.394531 299.792969 C 113.777344 292.464844 111.140625 282.792969 117.488281 270.773438 C 120.121094 267.308594 123.34375 264.964844 127.148438 263.738281 Z M 127.148438 263.738281 "
        />
        <path
          stroke="none"
          fillRule="evenodd"
          fill={frameColor}
          d="M 949.675781 478.710938 C 949.675781 483.988281 949.675781 489.265625 949.675781 494.539062 C 941.722656 505.640625 931.769531 507.695312 919.8125 500.695312 C 896.683594 472.851562 873.558594 445.003906 850.429688 417.15625 C 838.238281 613.511719 826.527344 809.902344 815.300781 1006.328125 C 815.089844 1014.734375 813.917969 1022.945312 811.785156 1030.949219 C 807.933594 1035.664062 802.957031 1038.300781 796.855469 1038.863281 C 598.949219 1040.035156 401.050781 1040.035156 203.144531 1038.863281 C 197.042969 1038.300781 192.070312 1035.664062 188.214844 1030.949219 C 186.082031 1022.945312 184.910156 1014.734375 184.699219 1006.328125 C 173.472656 809.902344 161.761719 613.511719 149.570312 417.15625 C 126.441406 445.003906 103.316406 472.851562 80.1875 500.695312 C 68.230469 507.695312 58.277344 505.640625 50.324219 494.539062 C 50.324219 489.265625 50.324219 483.988281 50.324219 478.710938 C 82.476562 440.355469 114.386719 401.664062 146.058594 362.636719 C 149.929688 358.171875 154.320312 354.359375 159.230469 351.207031 C 386.410156 350.035156 613.589844 350.035156 840.769531 351.207031 C 845.679688 354.359375 850.070312 358.171875 853.941406 362.636719 C 885.617188 401.664062 917.527344 440.355469 949.675781 478.710938 Z M 204.902344 389.019531 C 401.339844 386.96875 598.074219 386.675781 795.097656 388.140625 C 773.011719 415.960938 751.34375 444.101562 730.105469 472.558594 C 576.703125 473.730469 423.296875 473.730469 269.894531 472.558594 C 248.832031 444.113281 227.167969 416.265625 204.902344 389.019531 Z M 187.335938 427.710938 C 207.191406 452.589844 226.804688 477.800781 246.179688 503.335938 C 247.765625 505.445312 249.816406 506.914062 252.328125 507.730469 C 334.804688 509.765625 417.363281 510.644531 500 510.371094 C 582.636719 510.644531 665.195312 509.765625 747.671875 507.730469 C 750.183594 506.914062 752.234375 505.445312 753.820312 503.335938 C 773.140625 478.128906 792.464844 452.917969 811.785156 427.710938 C 804.148438 565.957031 795.949219 704.308594 787.195312 842.765625 C 756.457031 868.851562 725.714844 894.941406 694.976562 921.027344 C 565.578125 922.203125 436.179688 922.203125 306.78125 921.027344 C 276.007812 894.609375 244.972656 868.523438 213.683594 842.765625 C 204.351562 704.417969 195.566406 566.066406 187.335938 427.710938 Z M 215.441406 893.769531 C 233.933594 908.597656 252.085938 923.839844 269.894531 939.496094 C 254.097656 953.839844 237.996094 967.910156 221.589844 981.703125 C 218.410156 952.5 216.359375 923.1875 215.441406 893.769531 Z M 782.804688 893.769531 C 783.964844 896.941406 784.550781 900.460938 784.558594 904.320312 C 783.226562 930.207031 781.179688 956 778.410156 981.703125 C 762.308594 967.929688 746.210938 954.148438 730.105469 940.375 C 748.011719 925.074219 765.578125 909.539062 782.804688 893.769531 Z M 305.023438 958.839844 C 435.011719 958.546875 564.992188 958.839844 694.976562 959.71875 C 711.371094 973.789062 727.765625 987.859375 744.160156 1001.929688 C 581.386719 1003.101562 418.613281 1003.101562 255.839844 1001.929688 C 272.574219 987.804688 288.96875 973.441406 305.023438 958.839844 Z M 305.023438 958.839844 "
        />

        <path
          d="M 183.589844 407.371094 C 182.886719 395.410156 192.398438 385.320312 204.386719 385.320312 L 795.613281 385.320312 C 807.601562 385.320312 817.113281 395.410156 816.410156 407.371094 L 782.402344 985.351562 C 781.757812 996.359375 772.636719 1004.957031 761.605469 1004.957031 L 238.394531 1004.957031 C 227.363281 1004.957031 218.242188 996.359375 217.597656 985.351562 Z M 183.589844 407.371094 "
          stroke="none"
          fillRule="nonzero"
          fill={frameBackgroundColor}
        />
        <g
          stroke="null"
          transform="matrix(6.2212 0 0 6.2212 0 -55)"
          id="svg_485">
          <g
            dangerouslySetInnerHTML={{ __html: qrSvg }}
            stroke="null"
            id="svg_486"></g>
        </g>
        <text
          x="500"
          y="1200.3999700784689"
          dominantBaseline="middle"
          textAnchor="middle"
          fill={textColor}
          fontFamily="Nunito Sans"
          style={{ fontSize }}>
          {text}
        </text>
      </g>
    </svg>
  );
};
